// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Belt_Option from "../../../../../rescript/lib/es6/belt_Option.js";
import * as Json_decode from "../../../../../@glennsl/bs-json/src/Json_decode.bs.js";
import * as Env$Catalyst from "../Env.bs.js";

function execute(json) {
  return /* DefaultError */{
          _0: {
            title: {
              TAG: /* UnprocessedEntity */1,
              _0: Json_decode.optional((function (param) {
                      return Json_decode.field("title", Json_decode.string, param);
                    }), json)
            },
            message: Belt_Option.getWithDefault(Json_decode.optional((function (param) {
                        return Json_decode.field("message", Json_decode.string, param);
                      }), json), "Provided values cannot be processed")
          }
        };
}

var UnprocessedErrorHandler = {
  execute: execute
};

function execute$1(json) {
  return /* DefaultError */{
          _0: {
            title: /* NotAcceptableEntity */0,
            message: Belt_Option.getWithDefault(Json_decode.optional((function (param) {
                        return Json_decode.field("error", Json_decode.string, param);
                      }), json), "Provided values are not acceptable")
          }
        };
}

var NotAcceptableErrorHandler = {
  execute: execute$1
};

function execute$2(json) {
  return /* DefaultError */{
          _0: {
            title: /* Forbidden */2,
            message: Json_decode.field("message", Json_decode.string, json)
          }
        };
}

var ForbiddenErrorHandler = {
  execute: execute$2
};

function execute$3(json) {
  return /* DefaultError */{
          _0: {
            title: /* DataConflict */4,
            message: Json_decode.field("message", Json_decode.string, json)
          }
        };
}

var DataConflictErrorHandler = {
  execute: execute$3
};

function execute$4(param) {
  return /* DefaultError */{
          _0: {
            title: /* RequestTimeout */5,
            message: "Request timed out"
          }
        };
}

var RequestTimeoutHandler = {
  execute: execute$4
};

function execute$5(param) {
  return /* DefaultError */{
          _0: {
            title: /* FailedToFetch */6,
            message: "Failed to fetch."
          }
        };
}

var FailedToFetchErrorHandler = {
  execute: execute$5
};

function execute$6(param) {
  return /* DefaultError */{
          _0: {
            title: /* RequestCancelled */7,
            message: "Request Cancelled"
          }
        };
}

var RequestCancelledErrorHandler = {
  execute: execute$6
};

function execute$7(param) {
  return /* DefaultError */{
          _0: {
            title: /* OperationAborted */8,
            message: "Operation Aborted"
          }
        };
}

var OperationAbortedHandler = {
  execute: execute$7
};

function execute$8(data) {
  var match = Env$Catalyst.getWorkingEnv(undefined);
  if (match !== 0) {
    return /* DefaultError */{
            _0: {
              title: /* CorsError */9,
              message: data
            }
          };
  } else {
    return /* DefaultError */{
            _0: {
              title: /* FailedToFetch */6,
              message: "Failed to fetch."
            }
          };
  }
}

var CorsHandler = {
  execute: execute$8
};

function execute$9(_json) {
  return {
          title: "Resource Created",
          message: "Resource successfully created"
        };
}

var NoContentHandler = {
  execute: execute$9
};

function execute$10(json) {
  return {
          message: Json_decode.field("message", Json_decode.string, json),
          status: Json_decode.field("status", Json_decode.$$int, json)
        };
}

var PostApiHandler = {
  execute: execute$10
};

export {
  UnprocessedErrorHandler ,
  NotAcceptableErrorHandler ,
  ForbiddenErrorHandler ,
  DataConflictErrorHandler ,
  RequestTimeoutHandler ,
  FailedToFetchErrorHandler ,
  RequestCancelledErrorHandler ,
  OperationAbortedHandler ,
  CorsHandler ,
  NoContentHandler ,
  PostApiHandler ,
  
}
/* No side effect */
